import { SelectedOrganization, StepsLogin } from 'components'
import { Images, UserData } from 'interfaces'
import React, { useState } from 'react'

export const Login = (): JSX.Element => {
	const [step, setStep] = useState(0)
	const [user, setUser] = useState<UserData>({
		email: null,
		fullName: null,
		userId: null,
		organization_id: null,
		organization_name: null,
		organization_slug: null,
		roles: null,
		token: null
	})

	return (
		<div className="w-screen h-screen flex flex-col gap-4 items-center justify-center bg-gradient-to-b from-[#12B4C6] to-[#5E6F7E]">
			<div className="w-[250px] h-[44px] mb-8">
				<img
					src={Images.patterLogoLogin}
					alt="Logo"
					className="w-full h-full object-contain"
				/>
			</div>
			{step === 0 && (
				<StepsLogin user={user} setUser={setUser} setStep={setStep} />
			)}
			{step === 1 && <SelectedOrganization user={user} setStep={setStep} />}
		</div>
	)
}
